export default "__VITE_ASSET__D9x_RTxp__"